import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Table from "../../../../core/et3-table";
import { KHATTABAT_MATCHMAKING_AUDIT_HEADERS } from "../../../../constants/table-custom-headers/Khattabat";
import getMatchmakingAuditStore from "../../../../stores/khattabat-stores/khattabat-matchmaking-audit-store";

const MatchmakingAuditData = withLiteObserverAndTheme(() => {
  const matchmakingAuditStore = getMatchmakingAuditStore();

  return (
    <Et3Table
      columns={KHATTABAT_MATCHMAKING_AUDIT_HEADERS}
      rows={matchmakingAuditStore.matchmakingAuditData.get()}
      title={i18n.get("MATCHMAKING_AUDIT_DATA")}
      shouldBeFlagged={false}
      titleKey={"MATCHMAKING_AUDIT_DATA"}
    />
  );
});
export default MatchmakingAuditData;
